<script>
import CompanySelect from "./CompanySelect";
import NotificationAPI from "@/services/notifications/notificationsAPI";

/**
 * Topbar component
 */
export default {
  components: {
    CompanySelect,
  },
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/china.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      current_language: this.$i18n.locale,
      text: null,
      flag: null,
      value: null,
      username: JSON.parse(localStorage.getItem("user")) || {},

      classificationID:
        this.$store.getters["company/getCompany"].company_classification_id ||
        null,
      user: this.$store.state.auth || null,

      userData: this.$store.state.auth || null,

      company: this.$store.getters["company/getCompany"] || null,

      companyID: this.$store.getters["company/getCompany"].id || null,

      counter: 0,

      avatarText: null,

      lista: [],
      data: null,
    };
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === this.$i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    this.getAvatarText();
    this.getAllNotifications();
  },
  methods: {
    replaceCompany(message) {
      let text = "";

      text = message.replace("Nombreempresa", this.company.social_reason);
      text = text.replace("xxx", this.company.social_reason);
      text = text.replace(":nombreEmpresa", this.company.social_reason);

      return text;
    },

    getAllNotifications() {

      if (this.userData.info.role !== 2) {
        NotificationAPI.unread(this.companyID)
          .then((response) => {
            this.data = response.Notification.length || 0;
          })
          .catch((error) => {
            console.log(error);
          });

        NotificationAPI.getAllNotifications(this.companyID)
          .then((response) => {
            let datos = response.Notification.data;
            // console.log("Datos a mostrar: ", datos);

            if (datos.length > 5) {
              this.lista = datos.slice(0, 5);
            } else {
              this.lista = datos;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {

        NotificationAPI.unreadByUser(this.companyID, this.userData.info.sstID)
          .then((response) => {
            this.data = response.Notification.length || 0;
          })
          .catch((error) => {
            console.log(error);
          });

        NotificationAPI.getByUser(this.companyID, this.userData.info.sstID)
          .then((response) => {
            let datos = response.Notification.data;
            // console.log("Datos a mostrar: ", datos);

            if (datos.length > 5) {
              this.lista = datos.slice(0, 5);
            } else {
              this.lista = datos;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    getAvatarText() {
      if (this.username.nodexum.name) {
        const separate = this.username.nodexum.name.toUpperCase().split(" ");
        if (separate.length > 1) {
          this.avatarText = separate[0].charAt(0) + separate[1].charAt(0);
        } else {
          this.avatarText = separate[0].charAt(0) + separate[0].charAt(1);
        }
      } else {
        this.avatarText = "US";
      }
    },
    /**
     * Toggle menu
     */
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    /**
     * Full screen
     */
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },

    goRegisterPage() {
      this.$router.push({
        name: "notifications-list",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    /**
     * Toggle rightbar
     */
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    /**
     * Set languages
     */
    setLanguage(locale, country, flag) {
      this.$i18n.locale = locale;
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
    },
    /**
     * Horizontal-toggle menu
     */
    horizonalmenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
  },
};
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom" style="background-color: #00707f">
    <div class="container-fluid">
      <ul class="list-unstyled topnav-menu float-right mb-0">
        <li class="dropdown">
          <CompanySelect />
        </li>

        <li class="dropdown d-none d-lg-inline-block">
          <a
            class="nav-link dropdown-toggle arrow-none waves-effect waves-light"
            @click="initFullScreen"
            data-toggle="fullscreen"
            href="#"
          >
            <i class="fe-maximize noti-icon"></i>
          </a>
        </li>
        <b-nav-item-dropdown
          variant="white"
          class="d-none d-lg-inline-block topbar-dropdown"
          toggle-class="nav-link"
          right
          menu-class="dropdown-lg p-0"
        >
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          right
          class="notification-list"
          menu-class="dropdown-lg"
        >
          <template slot="button-content" class="nav-link dropdown-toggle">
            <i class="fe-bell noti-icon"></i>
            <span
              v-if="data"
              class="badge badge-danger rounded-circle noti-icon-badge"
            >
              {{ this.data }}
            </span>
          </template>

          <a href="#" class="dropdown-item noti-title">
            <h5 class="m-0">
              <!-- <span class="float-right">
               <a href class="text-dark">
                  <small>{{
                    $t("navbar.dropdown.notification.subtext")
                  }}</small>
                </a>
              </span>
              {{ $t("navbar.dropdown.notification.text") }}-->
              Notificaciones
            </h5>
          </a>
          <div v-if="lista.length > 0">
            <simplebar v-for="dato in lista" :key="dato.id">
              <a
                href="/forms/notifications-list"
                :class="`dropdown-item notify-item ${
                  dato.viewed ? 'active' : null
                }`"
              >
                <div class="notify-icon bg-soft-primary text-primary">
                  <i class="mdi mdi-comment-account-outline"></i>
                </div>
                <p class="notify-details">
                  {{ replaceCompany(dato.message.message) }}
                </p>
              </a>
            </simplebar>
          </div>

          <a
            v-else
            href="javascript:void(0);"
            class="dropdown-item notify-item active"
          >
            <p class="notify-details">No hay notificaciones que mostrar</p>
          </a>

          <a
            href="/forms/notifications-list"
            class="
              dropdown-item
              text-center text-primary
              notify-item notify-all
            "
          >
            Ver todas las notificaciones
            <!-- {{ $t("navbar.dropdown.notification.button") }}-->
            <i class="fi-arrow-right"></i>
          </a>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown
          right
          class="notification-list topbar-dropdown"
          menu-class="profile-dropdown"
          toggle-class="p-0"
        >
          <template slot="button-content" class="nav-link dropdown-toggle">
            <div class="nav-user mr-0">
              <b-avatar :text="avatarText"> </b-avatar>
              <span class="pro-user-name ml-1">
                {{ username ? $t(username.nodexum.name) : $t("Usuario") }}
                <i class="mdi mdi-chevron-down"></i>
              </span>
            </div>
          </template>

          <b-dropdown-header>
            <h6 class="text-overflow m-0 py-2">
              <!-- {{ $t("navbar.dropdown.name.list.greet") }}-->
              {{ $t("Bienvenido!") }}
            </h6>
          </b-dropdown-header>
          <!--
          <b-dropdown-item href="#">
            <i class="remixicon-account-circle-line"></i>
            <span>{{ $t("navbar.dropdown.name.list.account") }}</span>
            <span>{{ $t("Perfil") }}</span>
          </b-dropdown-item>

          <b-dropdown-item href="#">
            <i class="remixicon-settings-3-line"></i>
            <span>{{ $t("navbar.dropdown.name.list.settings") }}</span>
             <span>{{ $t("Ayuda") }}</span>
          </b-dropdown-item>
          -->

          <b-dropdown-divider></b-dropdown-divider>
          <a class="dropdown-item" href="/logout">
            <i class="fe-log-out mr-1"></i>
            <!-- <span>{{ $t("navbar.dropdown.name.list.logout") }}</span> -->
            <span>{{ $t("Salir") }}</span>
          </a>
        </b-nav-item-dropdown>
      </ul>

      <!-- LOGO -->
      <div class="logo-box">
        <router-link to="/" class="logo logo-dark text-center">
          <span class="logo-sm">
            <img src="@/assets/images/logoemi.png" alt height="47" />
            <!-- <span class="logo-lg-text-light">Minton</span> -->
          </span>
          <span class="logo-lg">
            <img src="@/assets/images/logoemi.png" alt height="45" />
            <!-- <span class="logo-lg-text-light">M</span> -->
          </span>
        </router-link>

        <router-link to="/" class="logo logo-light text-center">
          <span class="logo-sm">
            <img src="@/assets/images/corto.png" alt height="60" />
          </span>
          <span class="logo-lg">
            <img src="@/assets/images/logoemi.png" alt height="45" />
          </span>
        </router-link>
      </div>

      <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
        <li>
          <button
            class="button-menu-mobile waves-effect waves-light"
            @click="toggleMenu"
          >
            <i class="fe-menu"></i>
          </button>
        </li>

        <li>
          <!-- Mobile menu toggle (Horizontal Layout)-->
          <a
            class="navbar-toggle nav-link"
            data-toggle="collapse"
            @click="horizonalmenu()"
            data-target="#topnav-menu-content"
          >
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
          <!-- End mobile menu toggle-->
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>
  </div>
  <!-- end Topbar -->
</template>
